import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mediaQueries } from 'styles/utils/mediaQueries';
import Tooltip from 'rc-tooltip';
import { FormattedMessage } from 'i18n';

function OvernightIcon({ highlighted, isOvernight }) {
  if (!isOvernight) {
    return null;
  }
  return (
    <Tooltip
      placement='top'
      trigger={['hover']}
      overlayStyle={{ opacity: 1 }}
      overlay={
        <FormattedMessage id='flightIsOverNight' description='Overnight flight' defaultMessage='Overnight flight' />
      }
      destroyTooltipOnHide
    >
      <IconWrap highlighted={highlighted}>
        <FontAwesomeIcon icon='moon-cloud' />
      </IconWrap>
    </Tooltip>
  );
}

export default OvernightIcon;

const IconWrap = styled.div`
  color: ${({ theme, highlighted }) => (highlighted ? theme.colors.adjacent.default : theme.colors.text.light)};
  display: flex;
  align-items: center;
  padding: 3px 6px;
  border-radius: 10px;
  font-size: 16px;
  margin: 0 !important;
  ${({ small }) =>
    small &&
    ` padding:1px 1px;
    `}
  ${mediaQueries.fromAndBelow.tablet`
   padding:1px 1px;
    `}
`;
